import { useRouteMatch } from 'react-router';

import * as RouteNames from '../constants/RouteNames';

const useIsNoShowLeftNav = () => !!useRouteMatch([
    RouteNames.Profile,
    RouteNames.ThemeSettings,
    RouteNames.NavigationSettings,
    RouteNames.NotificationSettings,
    RouteNames.AddNotificationSettingsProfile,
    RouteNames.PrivacyAndSecuritySettings,
    RouteNames.OrganizationMigration,
    RouteNames.PersonalAccessToken,
]);

export default useIsNoShowLeftNav;
